import React from 'react';
import './Leave.css';

const leaveRecords = [
  {
    type: 'Sick Leave',
    from: '2025-06-10',
    to: '2025-06-12',
    status: 'Approved',
    reason: 'Fever and rest',
  },
  {
    type: 'Casual Leave',
    from: '2025-06-20',
    to: '2025-06-20',
    status: 'Pending',
    reason: 'Family event',
  },
  {
    type: 'Conference Leave',
    from: '2025-07-01',
    to: '2025-07-03',
    status: 'Approved',
    reason: 'Attending medical conference',
  },
];

const Leave = () => {
  return (
    <div className="leave-container">
      <h3>My Leave Summary</h3>

      <table className="data-table">
        <thead>
          <tr>
            <th>Type</th>
            <th>From</th>
            <th>To</th>
            <th>Status</th>
            <th>Reason</th>
          </tr>
        </thead>
        <tbody>
          {leaveRecords.map((leave, index) => (
            <tr key={index}>
              <td>{leave.type}</td>
              <td>{leave.from}</td>
              <td>{leave.to}</td>
              <td>{leave.status}</td>
              <td>{leave.reason}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Leave;